export default "__VITE_ASSET__8iDEXZop__"